import React from "react";

const StockSkeleton = () => {
  return (

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-4">
        <div className="space-y-3">
          <div className="flex items-baseline gap-20">
            <span className="h-4 w-16 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
            <span className="h-6 w-28 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
          </div>
          <div className="flex items-baseline gap-16">
            <span className="h-4 w-20 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
            <span className="h-6 w-24 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
          </div>
          <div className="flex items-baseline gap-8">
            <span className="h-4 w-28 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
            <span className="h-6 w-24 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
          </div>
          <div className="flex items-baseline gap-20">
            <span className="h-4 w-16 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
            <span className="h-6 w-20 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
          </div>
        </div>

        {/* Column 2 */}
        <div className="space-y-3">
          <div className="flex items-baseline gap-4">
            <span className="h-4 w-20 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
            <span className="h-6 w-24 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
          </div>
          <div className="flex items-baseline gap-14">
            <span className="h-4 w-10 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
            <span className="h-6 w-16 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
          </div>
        </div>

        {/* Column 3 */}
        <div className="space-y-3">
          <div className="flex items-baseline gap-8">
            <span className="h-4 w-28 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
            <span className="h-6 w-24 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
          </div>
          <div className="flex items-baseline gap-4">
            <span className="h-4 w-32 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
            <span className="h-6 w-28 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
          </div>
        </div>

        {/* Column 4 */}
        <div className="space-y-3">
          <div className="flex items-baseline gap-7">
            <span className="h-4 w-20 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
            <span className="h-6 w-24 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
          </div>
          <div className="flex items-baseline gap-5">
            <span className="h-4 w-20 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
            <span className="h-6 w-28 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
          </div>
        </div>
      </div>
  );
};

export default StockSkeleton;
